'use strict';

module.exports = function init(m) {

    m.constant('dfxDropDownEvents', {
        // item moves up/down within scrolled list
        DFX_DROPDOWN_ITEM_MOVE: 'dfx_dropdown_item_move',
        // query for scroll element
        DFX_DROPDOWN_SCROLL_SCROLL: 'dfx_dropdown_scroll_scroll',
    });

    m.directive('dfxDropdown', ['$document', 'dfxDropDownEvents', '$filter', function ($document, dfxDropDownEvents, $filter) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                'items': '=',
                'label': '@',
                'error': '@',
                'additionalClasses': '@',
                'isLoading': '=',
                'isDisabled': '=',
                'model': '=?',
                'isInvalid': '=?',
                'placement': '@',
                'placeholder': '@',
                'onItemSelect': '&'
            },
            controller: ['$scope', '$element', function ($scope, $element) {

                $scope.toggleDropdown = function () {
                    if ($scope.isDisabled || $scope.items.length < 1) {
                        return;
                    }
                    $scope.isOpen = !$scope.isOpen;
                };

                $scope.selectItem = function (item, fromModel) {
                    $scope.preselected = item;
                    $scope.selectedItem = item;
                    $scope.model = item;
                    $scope.isOpen = false;
                    if (!fromModel) {
                        $scope.onItemSelect && $scope.onItemSelect({item: item});
                    }
                };

                $scope.$watch('model', function (newval, oldval) {
                    $scope.selectItem(newval, true);
                });

                $scope.isPreselected = function (item) {
                    return $scope.preselected && $scope.preselected === item;
                };

                var inlineSelect = function (item) {
                    $scope.selectedItem = item;
                    $scope.preselected = item;
                    if (!$scope.isOpen) {
                        $scope.model = item;
                        $scope.onItemSelect && $scope.onItemSelect({item: item});
                    }
                };

                $scope.tabKey = function (event) {
                    switch (event.which) {
                        case 9:
                            $scope.selectItem($scope.selectedItem);
                            break;
                    }
                };

                $scope.keyBoardEvent = function (event) {
                    switch (event.which) {
                        case 40:
                            if ($scope.items.indexOf($scope.selectedItem) < $scope.items.length - 1) {
                                inlineSelect($scope.items[$scope.items.indexOf($scope.selectedItem) + 1]);
                            }
                            if ($scope.isOpen) {
                                $scope.$broadcast(dfxDropDownEvents.DFX_DROPDOWN_ITEM_MOVE);
                            }
                            event.preventDefault();
                            break;
                        case 38:
                            if ($scope.items.indexOf($scope.selectedItem) !== 0) {
                                inlineSelect($scope.items[$scope.items.indexOf($scope.selectedItem) - 1]);
                            }
                            if ($scope.isOpen) {
                                $scope.$broadcast(dfxDropDownEvents.DFX_DROPDOWN_ITEM_MOVE);
                            }
                            event.preventDefault();
                            break;
                        case 13:
                            if ($scope.isOpen) {
                                $scope.selectItem($scope.selectedItem);
                            } else {
                                $scope.toggleDropdown();
                            }
                            event.preventDefault();
                            break;
                        default:
                            if (!event.key) break;
                            var matchIdx = $scope.items
                                .map(function (e, idx) { return e.name[0].toLowerCase() === event.key.toLowerCase() ? idx : -1 })
                                .filter(function (e) { return e >= 0 })[0];
                            angular.isDefined(matchIdx) && inlineSelect($scope.items[matchIdx]);
                            if ($scope.isOpen) {
                                $scope.$broadcast(dfxDropDownEvents.DFX_DROPDOWN_ITEM_MOVE);
                            }
                            break;
                    }
                };
            }],

            link: function ($scope, elem, iAttrs) {

                var itemsContainer = elem[0].querySelector('.form-segment__dropped');

                $document.on('click', function (event) {
                    if (!$scope.isOpen || elem[0].contains(event.target)) {
                        return;
                    }

                    angular.element(itemsContainer).off('mouseover');

                    $scope.isOpen = false;
                    $scope.$apply();
                });

                angular.element(itemsContainer).on('mouseover', function (event) {
                    if ($scope.isOpen && $scope.preselected && elem[0].contains(event.target)) {
                        $scope.preselected = null;
                        $scope.$apply();
                    }
                });

            },

            templateUrl: 'template/directives/dropdown'
        }
    }]);

    m.directive('dfxDropdownContainer', ['dfxDropDownEvents', function (dfxDropDownEvents) {
        return {
            restrict: 'A',
            controller: ['$scope', '$element', function ($scope, $element) {
                $scope.$on(dfxDropDownEvents.DFX_DROPDOWN_SCROLL, function (event, offset) {
                    //var currentHeight = $element[0].clientHeight;
                    $element.scrollTop(offset /*- currentHeight*/);
                });
            }]
        }
    }]);

    m.directive('dfxDropdownItem', ['dfxDropDownEvents', function (dfxDropDownEvents) {
        return {
            restrict: 'A',
            controller: ['$scope', '$element', function ($scope, $element) {
                $scope.$on(dfxDropDownEvents.DFX_DROPDOWN_ITEM_MOVE, function (event, args) {
                    if ($scope.selectedItem === $scope.item) {
                        $scope.$emit(dfxDropDownEvents.DFX_DROPDOWN_SCROLL, $element[0].offsetTop - $element[0].clientHeight);
                    }
                });
            }]
        }
    }]);
};
